<template>
	<div style="width:100%; margin:0 37px">
		<v-layout align-center class="header_title">
			<!--  타이틀  -->
			<v-flex xs12>
				<v-layout align-center>
					<div class="slash mr-1"></div>
					<span class="">
						DB관리
					</span>
					<v-layout justify-end>
						<v-btn class="db_manage_copy_btn" @click="customUrlCopy()">상담사 url복사</v-btn>
					</v-layout>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-tabs :color="$store.state.PointColor1" background-color="#F4F8FD" v-model="tab" class="reservationTab" slider-size="1">
			<!-- :color="$store.state.PointColor2" -->
			<v-tab v-for="(tab, i) in tabs" :ripple="false" :key="i"> {{ tab }}</v-tab>
		</v-tabs>
		<v-tabs-items v-model="tab" style="margin-top:20px;  min-height: 500px;">
			<v-tab-item style="padding-top:20px;" v-if="tabItemAccess(tabs[0])">
				<marketingDB :nowTabs="tab" :tabIdx="checkTabChanged(tabs[0])"></marketingDB>
			</v-tab-item>
			<v-tab-item style="padding-top:20px;" v-if="tabItemAccess(tabs[1])">
				<marketingCampaignManagement :nowTabs="tab" :tabIdx="checkTabChanged(tabs[1])"></marketingCampaignManagement>
			</v-tab-item>
			<v-tab-item style="padding-top:20px;" v-if="tabItemAccess(tabs[2])">
				<marketingCircumstance :nowTabs="tab" :tabIdx="checkTabChanged(tabs[2])"></marketingCircumstance>
			</v-tab-item>
			<v-tab-item style="padding-top:16px;" v-if="tabItemAccess(tabs[3])">
				<marketingDBCustomerCircumstance :nowTabs="tab" :tabIdx="checkTabChanged(tabs[3])"></marketingDBCustomerCircumstance>
			</v-tab-item>
			<v-tab-item style="padding-top:20px;" v-if="tabItemAccess(tabs[4])">
				<marketingMarketer :nowTabs="tab" :tabIdx="checkTabChanged(tabs[4])"></marketingMarketer>
			</v-tab-item>
			<v-tab-item style="padding-top:20px;" v-if="tabItemAccess(tabs[5])">
				<marketingReport :nowTabs="tab" :tabIdx="checkTabChanged(tabs[5])"></marketingReport>
			</v-tab-item>
		</v-tabs-items>
		<sweetAlert :dialog="sweetInfo" />
	</div>
</template>

<script>
import marketingReport from '../viewItem/marketingReport.vue'
import marketingDB from '../viewItem/marketingDB.vue'
import marketingCircumstance from '../viewItem/marketingCircumstance.vue'
import marketingCampaignManagement from '../viewItem/marketingCampaignManagement.vue'
import marketingMarketer from '../viewItem/marketingMarketer.vue'
import marketingDBCustomerCircumstance from '../viewItem/marketingDBCustomerCircumstance.vue'
import { sweetAlert } from '@/components/index.js'
export default {
	components: {
		marketingReport,
		marketingDB,
		marketingCircumstance,
		marketingCampaignManagement,
		marketingMarketer,
		marketingDBCustomerCircumstance,
		sweetAlert,
	},
	mounted() {},
	async created() {
		await this.reservedays_call()
	},

	methods: {
		/** 상담사 url 복사
		@author 임호진
		*/
		customUrlCopy() {
			const dummy = document.createElement('input')
			const text = this.customerURL
			document.body.appendChild(dummy)
			dummy.value = text
			dummy.select()
			document.execCommand('copy')
			document.body.removeChild(dummy)

			this.sweetInfo.open = true
			this.sweetInfo.title = '복사 완료'
			this.sweetInfo.content = `ctrl + v로 url을 확인하세요.`
		},

		checkTabChanged(keyValue) {
			const arr_auth = this.tabs
			return arr_auth.findIndex(el => el === keyValue)
		},

		/**** 접근 가능한 탭 목록 
 @author 전현균 
 */
		tabsAccess() {
			const me_menu = this.$store.state.meData.adminMenu
			if (this.$store.state.meData.role && (this.$store.state.meData.role.id === '1' || this.$store.state.meData.role.id === 1)) {
				return this.tabs
			} else if (me_menu && me_menu.length > 0) {
				const me_access = me_menu.filter(menu => menu.route === 'dbManagement')
				const tab_access = this.tabs.filter(tab => me_access[0].secondDepth.filter(access => access.secondDepth === tab).length > 0)
				return tab_access
			} else {
				return []
			}
		},

		/**** 접근 가능한 탭 목록의 아이템 렌더링 
 @author 전현균 
 */
		tabItemAccess(route) {
			const tab_access = this.tabs

			if (tab_access.indexOf(route) !== -1) {
				return true
			} else {
				return false
			}
		},

		async reservedays_call() {
			// 프로젝트 리스트 호출

			this.$store.dispatch('bizTitle').then(res => {
				let data = res.data.bizTitle.businesses
				data.sort((a, b) => {
					return a.id - b.id
				})
				this.$store.state.businesses_list_system.items = data.map(el => {
					return { text: el.title, value: { id: el.id } }
				})
				this.$store.state.businesses_list_system.value = this.$store.state.businesses_list_system.items[0].value
				this.$store.state.businesses_lists = res.data.bizTitle.businesses
			})
		},

		viewDay({ date }) {
			this.focus = date
			this.type = 'day'
		},
		getEventColor(event) {
			return event.color
		},
		setToday() {
			this.focus = ''
		},

		showEvent({ nativeEvent, event }) {
			const open = () => {
				this.selectedEvent = event
				this.selectedElement = nativeEvent.target
				requestAnimationFrame(() => requestAnimationFrame(() => (this.selectedOpen = true)))
			}

			if (this.selectedOpen) {
				this.selectedOpen = false
				requestAnimationFrame(() => requestAnimationFrame(() => open()))
			} else {
				open()
			}

			nativeEvent.stopPropagation()
		},
		updateRange({ start, end }) {
			const events = []

			const min = new Date(`${start.date}T00:00:00`)
			const max = new Date(`${end.date}T23:59:59`)
			const days = (max.getTime() - min.getTime()) / 86400000
			const eventCount = this.rnd(days, days + 20)

			for (let i = 0; i < eventCount; i++) {
				const allDay = this.rnd(0, 3) === 0
				const firstTimestamp = this.rnd(min.getTime(), max.getTime())
				const first = new Date(firstTimestamp - (firstTimestamp % 900000))
				const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
				const second = new Date(first.getTime() + secondTimestamp)

				events.push({
					name: this.names[this.rnd(0, this.names.length - 1)],
					start: first,
					end: second,
					color: this.colors[this.rnd(0, this.colors.length - 1)],
					timed: !allDay,
				})
			}

			this.events = events
		},
		rnd(a, b) {
			return Math.floor((b - a + 1) * Math.random()) + a
		},
		sample() {},
		change() {
			// 상단 셀렉트 박스 change
			this.$refs.terms.terms_call()
		},
	},
	data() {
		return {
			tab: 0, // tab,
			tabs: ['마케팅DB 관리', '캠페인 관리', '캠페인 현황 관리', '마케팅DB 고객 현황', '마케터 관리', '마케팅 통계 관리'],
			// 복사 alert
			sweetInfo: {
				open: false,
				title: '복사 완료',
				content: `ctrl + v로 코드를 확인하세요.`,
				modalIcon: 'success',
				cancelBtnText: '확인',
				buttonType: 'oneBtn',
			},
			// 상담사 urls
			customerTestURL: 'http://1.230.77.225:83/login/',
			customerURL: 'https://pick-here-8686d.web.app/login',
		}
	},
}
</script>
<style lang="scss" scoped>
.db_manage_copy_btn {
	background-color: #323153 !important;
	color: white !important;
	height: 26px !important;
	font-size: 13px !important;
	font-weight: bold !important;
}
.left_dashboard {
	background-color: white;
	border-radius: 1vh;
}
</style>
<style lang="scss"></style>
